<template>
  <div class="px-4">
    <p class="font-semibold text-xl">
      {{ assignmentName }}
    </p>
    <p class="font-semibold text-4xl text-primary-500">
      Assignees
    </p>
    <hr>
    <d-field label="Filter">
      <d-input v-model="assigneesFilter" @input="filterAssignees" />
    </d-field>
    <template v-for="userAssignment in filteredUserAssignments">
      <a :key="`content-${userAssignment.id}`" :href="`/assignments/${userAssignment.id}`" class="no-underline">
        <div class="items-center flex">
          <div>
            <p class="">{{ userAssignment.userFullName }}</p>
            <p class="text-sm text-gray-600">{{ userAssignment.completedToDosRatio.completed }} of {{ userAssignment.completedToDosRatio.outOfTotal }} task completed</p>
            <p v-if="userAssignment.itemsReadyForReviewCount>0" class="text-sm text-red-600"> {{ userAssignment.itemsReadyForReviewCount }} tasks ready for review</p>
          </div>
          <d-icon v-if="userAssignment.completedToDosRatio.completed === userAssignment.completedToDosRatio.outOfTotal || userAssignment.completed" icon="check" class="text-green-500 ml-5 text-lg" />
        </div>
        <div class="items-center flex mb-4">
          <div v-if="userAssignment.completed" class="text-sm text-gray-600">Assignment fully completed</div>
        </div>
      </a>
    </template>
  </div>
</template>
<script>
  import axios from 'axios';
  import _ from 'lodash';

  export default {

    props: {

      groupName: {
        type: String,
        default: () => '',
      },
      assignmentTemplateId: {
        type: Number,
        default: () => 0,
      },
    },
    data: () => ({
      loadingUserAssignments: false,
      userAssignments: [],
      assigneesFilter: '',
      filteredUserAssignments: [],
      assignmentName: '',
    }),

    mounted() {
      this.getUserAssignmentsByAssignmentTemplateId();
    },

    methods: {
      filterAssignees() {
        if (this.assigneesFilter) {
          this.filteredUserAssignments = this.userAssignments.filter((x) => x.userFullName.toLowerCase().includes(this.assigneesFilter.toLowerCase()));
        } else {
          this.filteredUserAssignments = this.userAssignments;
        }
      },

      async getUserAssignmentsByAssignmentTemplateId() {
        this.loadingUserAssignments = true;
        const { data } = await axios.get(`/api/user/assignment-template/${this.assignmentTemplateId}`);
        this.userAssignments = data;
        this.filteredUserAssignments = data;
        this.loadingAssignments = false;
        this.assignmentName = this.filteredUserAssignments[0].assignmentName;
      },
    },
  };
</script>